import type { ParticipantsCardProps } from "../_model";
import SendIcon from "../assets/icons/send-2.svg";
import { request } from "../apis";
import { global } from ":shared/app";
import { Button } from ":ui/form";

export default function ParticipantsCard(props: ParticipantsCardProps) {
  async function onSendInvite() {
    const requester_email = global.api.auth.events.getUserEmail();
    const data = {
      requester_email: requester_email,
      receiver_email: props.email,
      status: "pending",
    };
    return await request.post(JSON.stringify(data)).then(() => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Invite Sent",
      });
    });
  }

  return (
    <div class="flex flex-col w-full h-350px  bg-bg px-3 pt-2 border-1 border-solid border-border-card rounded-xl">
      <div class="flex flex-col w-100px h-100px">
        <img
          width={100}
          height={100}
          class="w-full h-full rounded-full object-cover "
          src={props?.image ?? "/images/placeholders/person.png"}
          alt="img"
          loading="lazy"
        />
      </div>

      <p class="w-fit  bg-bg-button text-text-button text-12px   px-2 my-2  rounded-md self-end">
        {props?.track ?? "No track"}
      </p>
      <p class="w-full text-black font-bold text-18px mb-1">
        {props?.first_name || props?.last_name ? `${props?.first_name || ""} ${props?.last_name || ""}` : "No name"}
      </p>
      {props?.portfolio != undefined ? (
        <a
          //
          class="text-16px"
          href={props?.portfolio ? props?.portfolio : ""}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p class="text-brand underline text-15px cursor-pointer">Preview Protofolio</p>
        </a>
      ) : (
        <span class="text-16px">No Portfolio</span>
      )}

      <p class="w-full h-full text-14px text-text-alt  text-start overflow-auto mt-1 mb-2">
        {props?.bio == undefined || props?.bio?.length <= 0 ? "No bio" : props.bio}
      </p>

      <Button
        //
        controls={{}}
        class={"form-btn !mt-1 " + " " + (props.team != undefined ? "disabled:(!bg-error-shade text-error)" : "")}
        triggers={{
          manualStatus: props.team == undefined ? "valid" : "invalid",
        }}
        onSubmit={(e) => {
          return onSendInvite();
        }}
        statusInvalid={"Part Of Team " + String(props.team)}
        statusValid={"Send Request"}
      />
    </div>
  );
}
